import axios from 'axios';

const state = () => ({
  features: [],
  roles: [],
  roleFeatures: {},
  addableFeatures: [],  // superuser-only — features not yet enabled for tenant
  loaded: false,
});

const mutations = {
  SET_CONFIG(state, { features, roles, role_features, addable_features }) {
    state.features = features;
    state.roles = roles;
    state.roleFeatures = role_features;
    state.addableFeatures = addable_features || [];
    state.loaded = true;
  },
  CLEAR_CONFIG(state) {
    state.features = [];
    state.roles = [];
    state.roleFeatures = {};
    state.addableFeatures = [];
    state.loaded = false;
  },
};

const actions = {
  async fetchConfig({ commit, rootGetters }) {
    const tenantSlug = rootGetters['tenant/current_tenant_slug'];
    if (!tenantSlug) return;
    // Clear before fetching so a slow or failing request never leaves stale
    // cross-tenant data visible to components.
    commit('CLEAR_CONFIG');
    try {
      const { data } = await axios.get('/api/features-config/');
      // Guard against overlapping tenant switches: if the user changed tenants
      // while this request was in flight, the response is for a now-stale
      // tenant — drop it.
      if (rootGetters['tenant/current_tenant_slug'] !== tenantSlug) return;
      commit('SET_CONFIG', data);
    } catch (error) {
      console.error('Failed to fetch features config:', error);
      // State already cleared above; leave empty rather than stale.
    }
  },
  clearConfig({ commit }) {
    commit('CLEAR_CONFIG');
  },
};

const getters = {
  features: (state) => state.features,
  // All roles as returned by the backend, including hide_from_config=true
  // entries. Used by flows that need to resolve a role_id a user is actually
  // assigned to (e.g. pretty-printing role names in user tables). Consumers
  // that are rendering a role-configuration surface should use visibleRoles.
  roles: (state) => state.roles,
  roleFeatures: (state) => state.roleFeatures,
  addableFeatures: (state) => state.addableFeatures,
  // Roles that should appear in role-configuration UI (the role matrix, the
  // role preview dropdown, etc). Hidden roles (hide_from_config=true) stay in
  // the system for legacy assignment but must not surface for editing.
  visibleRoles: (state) => state.roles.filter(r => !r.hide_from_config),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
